<template>
  <div id="app-block" class="card-container-outline mt-1 mb-1 no-p" @click="pushAppRedirect()">
    <div class="inner-padding row align-items-center gap-1">
      <div class="image-container">
        <img class="app-icon" :src="require('@/assets/img/' + appInfo.appIcon)">
      </div>
      <div class="col app-info-container" :class="colorTheme">
        <div class="tag">companion app 🔎</div>
        <p class="app-name">{{ appInfo.appName }}</p>
        <p class="no-pb">available on <a :href="appInfo.appLinks.iOS">iOS</a> and <a :href="appInfo.appLinks.android">Android</a></p>
      </div>
    </div>
  </div>
</template>


<script>
import router from "@/router/index.js";

export default {
  name: "CompanionAppHighlight",
  props: ['appName', 'color'],
  methods: {
    pushAppRedirect() {
      router.push(this.appInfo.appRedirect);
    },
  },
  computed: {
    appInfo() {
      return this.$store.getters.getAppInfoByName(this.appName);
    },
    colorTheme() {
      return this.color + '-theme';
    }
  }
}
</script>


<style scoped lang="scss">
@import '../assets/styles/variables.scss';

#app-block {
  width: 100%;
  max-width: 100%;
  cursor: pointer;

  .row {
    flex-wrap: nowrap;
  }

  p.app-name {
    font-weight: bold;
    font-size: 1.2em;
    font-family: 'Poppins', sans-serif;
    padding-bottom: 0;
  }

  img.app-icon {
    width: 100%;
    border-radius: 20px;
  }

  .image-container {
    flex-basis: 20%;
    min-width: 100px;
  }

  .app-info-container {
    flex-basis: calc(80% - 1em);
  }

  .tag {
    margin-bottom: 1em;
  }
  .inner-padding {
    padding: .8em;
  }

  .green-theme {
    color: $tosola-dark-green;

    .tag {
      background-color: $tosola-light-green;
      color: $tosola-dark-green;
    }

    a {
      color: $tosola-dark-green;
    }
  }

  .blue-theme {
    color: $blue;

    .tag {
      background-color: $blue;
      color: $teal;
    }

    a {
      color: $blue;
    }
  }
}
</style>